import MileageListingFilter, {
  MileageListingCardNumberFilter,
  MileageListingMileageDateFilter,
  MileageListingDistanceFilter,
  MileageListingEndAddressFilter,
  MileageListingHumanIdFilter,
  MileageListingMileageNumberFilter,
  MileageListingStartAddressFilter,
  MileageListingWorkerNameFilter,
  MileageListingCargoCompanyNameFilter,
  MileageListingVehicleTypeFilter,
} from "./types/mileage-listing-filter";
import MileageListingFilterType from "./types/mileage-listing-filter-type";
import MileageListingVehicleType from "./types/mileage-listing-vehicle-type";
import DelegationAddFromAllMileagesParams, {
  DelegationAddFromAllMileagesParamsVehicleType,
} from "../../../../common/services/delegation/add-from-all-mileages/delegation-add-from-all-mileages-params";
import mileageTranslationsHelper from "../../../../languages/mileage-translations.helper";
import notificationService from "../../../../common/utils/notification/notification.service";

const createVehicleType = (
  type: MileageListingVehicleType | undefined,
): DelegationAddFromAllMileagesParamsVehicleType | undefined => {
  switch (type) {
    case MileageListingVehicleType.CAR_GT_900CM3:
      return DelegationAddFromAllMileagesParamsVehicleType.CAR_GT_900CM3;
    case MileageListingVehicleType.CAR_LE_900CM3:
      return DelegationAddFromAllMileagesParamsVehicleType.CAR_LE_900CM3;
    case MileageListingVehicleType.COMPANY_OWNED:
      return DelegationAddFromAllMileagesParamsVehicleType.COMPANY_OWNED;
    case MileageListingVehicleType.MOPED:
      return DelegationAddFromAllMileagesParamsVehicleType.MOPED;
    case MileageListingVehicleType.MOTORCYCLE:
      return DelegationAddFromAllMileagesParamsVehicleType.MOTORCYCLE;
    default:
      return undefined;
  }
};

const create = (
  filters: MileageListingFilter[],
): DelegationAddFromAllMileagesParams => {
  const dateFilter = filters.find(
    (filter) => filter.type == MileageListingFilterType.MILEAGE_DATE,
  )?.value as MileageListingMileageDateFilter["value"] | undefined;

  const distanceFilter = filters.find(
    (filter) => filter.type == MileageListingFilterType.DISTANCE,
  )?.value as MileageListingDistanceFilter["value"] | undefined;

  const startAddress = filters.find(
    (filter) => filter.type == MileageListingFilterType.START_ADDRESS,
  )?.value as MileageListingStartAddressFilter["value"] | undefined;

  const endAddress = filters.find(
    (filter) => filter.type == MileageListingFilterType.END_ADDRESS,
  )?.value as MileageListingEndAddressFilter["value"] | undefined;

  const vehicleType = filters.find(
    (filter) => filter.type == MileageListingFilterType.VEHICLE_TYPE,
  )?.value as MileageListingVehicleTypeFilter["value"] | undefined;

  return {
    dateSince: dateFilter?.from,
    dateTo: dateFilter?.to,
    humanId: filters.find(
      (filter) => filter.type == MileageListingFilterType.HUMAN_ID,
    )?.value as MileageListingHumanIdFilter["value"] | undefined,
    mileageNumber: filters.find(
      (filter) => filter.type == MileageListingFilterType.MILEAGE_NUMBER,
    )?.value as MileageListingMileageNumberFilter["value"] | undefined,
    workerName: filters.find(
      (filter) => filter.type == MileageListingFilterType.WORKER_NAME,
    )?.value as MileageListingWorkerNameFilter["value"] | undefined,
    cardNumber: filters.find(
      (filter) => filter.type == MileageListingFilterType.CARD_NUMBER,
    )?.value as MileageListingCardNumberFilter["value"] | undefined,
    cargoCompanyName: filters.find(
      (filter) => filter.type == MileageListingFilterType.CARGO_COMPANY_NAME,
    )?.value as MileageListingCargoCompanyNameFilter["value"] | undefined,
    vehicleType: createVehicleType(vehicleType),
    startAddress: startAddress ? [startAddress] : undefined,
    endAddress: endAddress ? [endAddress] : undefined,
    distanceMin: distanceFilter?.from,
    distanceMax: distanceFilter?.to,
  };
};

const createErrorMessage = (): string => {
  const translations =
    mileageTranslationsHelper.getMileageListingTranslations();

  return translations.header.noMileagesAvailableNotificationText;
};

const mileageListingAutoGenerateParamsFactory = {
  create,
  createErrorMessage,
};

export default mileageListingAutoGenerateParamsFactory;
